import React from 'react'
import { useFormik } from 'formik'
import { GxForm } from '@garpix/garpix-web-components-react'
import Button from '@/components/Button'
import Checkbox from '@/components/Checkbox'
import ErrorAllText from '@/components/ErrorText/AllErros'
import Input from '@/components/Input'
import InputPhone from '@/components/InputPhone'
import Spinner from '@/components/Spinner/Spinner'
import { StateSelect } from '@/components/Select'
import { useCurrentUser, useModal } from '@/hooks'
import { profileInfoSchema } from '@/utils/schemesFormik'
import { api } from '@/api'
import style from './styles/profile.module.scss'

const Profile = (): React.ReactElement => {
  const { currentUser } = useCurrentUser()
  const { openModal } = useModal()

  const handleOpenModal = (): void => {
    openModal('changePassword', {})
  }

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: profileInfoSchema,
    initialValues: {
      login: currentUser?.login,
      email: currentUser?.email,
      name: currentUser?.name,
      // last_name: currentUser?.last_name,
      // second_name: currentUser?.second_name,
      personal_birthday: currentUser?.personal_birthday,
      personal_state: currentUser?.personal_state,
      personal_city: currentUser?.personal_city,
      // uf_school: currentUser?.uf_school,
      personal_phone: currentUser?.personal_phone,
      uf_show_user_data: currentUser?.uf_show_user_data ?? '0',
      uf_notifications: currentUser?.uf_notifications ?? '0',
      errorText: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit (values, { setSubmitting, setFieldError }) {
      api
        .updateUser(values)
        .then(response => {
          setSubmitting(false)
        })
        .catch((error: { response: any }) => {
          if (error.response !== undefined) {
            setFieldError('errorText', error.response.data.errorText)
          }
        })
    }
  })

  const handleChangePhone = async (e): Promise<void> => {
    await formik.setFieldValue('personal_phone', e.detail.value)
  }

  const handleCheckbox = async (e): Promise<void> => {
    const checked = e.target.checked
    const name = e.target.name
    await formik.setFieldValue(name, checked === true ? '1' : '0')
  }

  const onSubmit = formik.submitForm

  return (
    <div className={style.profile}>
      <GxForm onGx-submit={onSubmit}>
        <div className={style.profile_grid}>
          <Input
            name='login'
            label='Логин:'
            type='text'
            required
            value={formik.values.login}
            onGx-input={formik.handleChange}
            error={formik.errors.login}
            className={style.form__field}
          />
          {/* <Input
            name='last_name'
            label='Фамилия:'
            type='text'
            required
            value={formik.values.last_name}
            onGx-input={formik.handleChange}
            error={formik.errors.last_name}
            className={style.form__field}
          /> */}
          <Input
            name='name'
            label='Имя:'
            type='text'
            required
            value={formik.values.name}
            onGx-input={formik.handleChange}
            error={formik.errors.name}
            className={style.form__field}
          />
          {/* <Input
            name='second_name'
            label='Отчество:'
            type='text'
            value={formik.values.second_name}
            onGx-input={formik.handleChange}
            error={formik.errors.second_name}
            className={style.form__field}
          /> */}
          <Input
            name='personal_birthday'
            label='Дата рождения:'
            type='text'
            placeholder='дд.мм.гггг'
            required
            value={formik.values.personal_birthday}
            onGx-input={formik.handleChange}
            error={formik.errors.personal_birthday}
            className={style.form__field}
          />
          <StateSelect
            name='personal_state'
            label='Область/край:'
            required
            value={formik.values.personal_state}
            onGx-change={formik.handleChange}
            error={formik.errors.personal_state}
            className={style.form__field}
          />
          <Input
            name='personal_city'
            label='Город:'
            type='text'
            required
            value={formik.values.personal_city}
            onGx-input={formik.handleChange}
            error={formik.errors.personal_city}
            className={style.form__field}
          />
          {/* <Input
            name='uf_school'
            label='Учебное заведение:'
            type='text'
            required
            value={formik.values.uf_school}
            onGx-input={formik.handleChange}
            error={formik.errors.uf_school}
            className={style.form__field}
          /> */}
          <InputPhone
            name='personal_phone'
            label='Телефон:'
            type='text'
            value={formik.values.personal_phone}
            onGx-change={handleChangePhone}
            error={formik.errors.personal_phone}
            className={style.form__field}
          />
          <Input
            name='email'
            label='Почта:'
            type='email'
            required
            value={formik.values.email}
            onGx-input={formik.handleChange}
            error={formik.errors.email}
            className={style.form__field}
          />
          <div className={style.form__checkboxes}>
            <Checkbox
              name='uf_notifications'
              onGx-change={handleCheckbox}
              value='1'
              className={style.form__checkbox}
              checked={formik.values.uf_notifications === '1'}
            >
              Включить уведомления на почту
            </Checkbox>
          </div>
        </div>
        {formik.errors.errorText !== ''
          ? (
            <div>
              <ErrorAllText text={formik.errors.errorText} />
            </div>
            )
          : null}
        <div className={style.form_buttons}>
          <Button
            wide
            size='large'
            theme='secondary'
            onClick={handleOpenModal}
            className={style.form_buttons__change}
          >
            Изменить пароль
          </Button>
          <Button
            wide
            size='large'
            highlight
            type='submit'
            className={style.form_buttons__save}
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? <Spinner slot='icon-left' /> : 'Сохранить'}
          </Button>
        </div>
      </GxForm>
    </div>
  )
}

export default Profile
